import React from "react";
import { connect } from "react-redux";
import ReportTableContainer from "./ReportTableContainer";
import PropTypes from "prop-types";
import { showReport, emptyReport, takeReport } from "../Module";
import moment from "moment-jalaali";

@connect(
  (state) => ({
    dataReport: state.Attendance.Reports.dataReport,
    columns: state.Attendance.Reports.columns,
    properties: state.Attendance.Reports.properties,
  }),
  {
    showReport,
    emptyReport,
    takeReport,
  }
)
@autobind
export default class ReportTableContainerWrapper extends React.PureComponent {
  static propTypes = {
    columns: PropTypes.array,
    dataReport: PropTypes.array,
    properties: PropTypes.object,
    onCancel: PropTypes.func,
    showReport: PropTypes.func,
    emptyReport: PropTypes.func,
    params: PropTypes.object,
    report: PropTypes.object,
    reportBuilder: PropTypes.bool,
  };
  static defaultProps = {
    reportBuilder: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  createDateParamsFromRange = (rangeStr = "1-days") => {
    let rangeData = rangeStr.split("-");
    let data = {};
    data.dateFrom = moment().format("YYYY-MM-DD");
    data.dateTo = moment(
      moment().subtract(rangeData[0] || "1", rangeData[1] || "days")
    ).format("YYYY-MM-DD");
    return data;
  };

  /**
   *
   */
  componentDidMount() {
    const { showReport, takeReport, params, report, reportBuilder } =
      this.props;

    this.setState({ loading: true });
    if (reportBuilder) {
      let data = {
        dateFrom: report.dateFrom,
        dateTo: report.dateTo,
      };
      if (report && report.form && report.form.range) {
        let range = report.form.range;
        data = this.createDateParamsFromRange(range);
      }
      takeReport(report.id, data, () => {
        this.setState({ loading: false });
      });
    } else {
      showReport(report.id, params, () => {
        this.setState({ loading: false });
      });
    }
  }

  
  componentWillUnmount() {
    super.componentWillUnmount();
    this.props.emptyReport();
  }
  render() {
    const {
      columns,
      dataReport,
      properties,
      onCancel,
      report,
      emptyReport,
      reportBuilder,
    } = this.props;
    const { loading } = this.state;
    console.log("columnscolumnscolumns", dataReport);
    console.log("columnscolumnscolumns", columns);

    return (
      <ReportTableContainer
        report={report}
        reportBuilder={reportBuilder}
        loading={loading}
        title={`گزارش ${report.label}`}
        columns={columns.columns}
        dataSource={dataReport}
        onCancel={onCancel}
        beforeOnCancel={emptyReport}
        properties={properties}
      />
    );
  }
}
